import { useEffect, useState } from "react";

/**
 * Forces a re-render on an interval (e.g. live duration columns).
 * Pair with Date.now() in render so SignalR-driven re-renders also refresh the value.
 */
export function useIntervalTick(intervalMs = 5000, enabled = true) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    const id = window.setInterval(() => {
      setTick((n) => n + 1);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs, enabled]);
}
